export const COLORS_CHART = ['#66B28A', '#7E89A5', '#409BFF'];
